import styled from 'styled-components';
import HappyAngleLeftSvg from './happyAngleRight.svg';

const HappyAngleLeftIcon = styled(HappyAngleLeftSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '1.5rem'};
  height: ${props => props.height || '1.5rem'};
  margin: ${props => props.margin};
  fill: ${props => props.fill || props.theme.colors.ash.base};
  transform: rotate(-180deg);
  cursor: pointer;
`;

export default HappyAngleLeftIcon;
